import React, { useState, useEffect } from "react";
import _ from "lodash";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import { requestSuccess } from "utils/requestHandler";
import { useRef } from "react";

const PurchaseMonumentForm = (props) => {
  const isSubmittingRef = useRef(false);
  const { selectedItems } = props; // Destructure selectedItems from props
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    props.getParamOptions("paymentOptions", "PaymentType");
    props.getProductsOptions();
    if (props.getSubAdminRoles) {
      props.getSubAdminRoles();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const resetForm = () => {
    setStep(1);
    setFormData({});
  };

  // Generate sales payload
  const salesPayload = (value, bindID) => {


    const productCode = formData.step2?.selectedMonument || "DEFAULT_MONUMENT"; // ✅ Use selectedMonument

    const items = [
      {
        productCode: productCode, // ✅ Assign selectedMonument
        quantity: 1,
        paymentDetails: {
          downpayment: formData.step2?.lot?.downpayment || 0,
          loanDetails: {
            installmentMonth: formData.step2?.lot?.loanDetails?.installmentMonth || 1,
            sumPerInstallment: formData.step2?.lot?.loanDetails?.sumPerInstallment || 1,
          },
          unitPrice: formData.step2?.lot?.unitPrice || 0,
          unitDiscount: formData.step2?.lot?.unitDiscount || 0,
          maintenanceFee: formData.step2?.lot?.maintenanceFee || 0,
        },
      },
    ];

    if (_.isEmpty(items)) {
      console.error("🚨 API validation will fail! `items` array is empty.");
    }

    const payload = {
      salesByID: props.profile?.MemberId || "",
      purchaserID: formData.step1?.purchaserID?.MemberId || "",
      memberID: formData.step1?.memberID?.MemberId || "",
      paymentType: value.paymentType?.toString() || "",
      remarks: value.remarks || "Monument Sales",
      receipt: value.receipt?.base64 || "",
      salesType: "9",
      bindUnitSalesID: value.salesID || "", // ✅ Bind `salesID` from Step3
      introducerDetail: value.introducerDetail,
      dialectGroupName: formData.step2?.dialectGroupName || "",
      dialectGroupValue: formData.step2?.dialectGroupValue || "",
      needCondition: formData.step1?.needCondition || false,

      items, // ✅ Ensure Step 2 details are included
    };

    console.log("Final Payload Sent to API:", JSON.stringify(payload, null, 2));

    return payload;
  };

  const handleSuccess = (response) => {
    console.log("✅ Submission Success:", response);
    requestSuccess(response.Message);

    // Reset the form and navigate back to step 1
    resetForm();

    // Ensure UI updates properly after resetting state
    setTimeout(() => {
      isSubmittingRef.current = false;
      setStep(1);  // ✅ Ensure user goes back to the first step
    }, 500);
  };

  return (
    <>
      {step === 1 && (
        <Step1
          {...props}
          formData={formData.step1}
          disabledPurchaserID={props.disabledPurchaserID}
          hideCreateNewPurchaser={props.hideCreateNewPurchaser}
          onNext={(value) => {
            setStep(step + 1);
            setFormData({
              ...formData,
              step1: value,
            });
          }}
        />
      )}
      {step === 2 && (
        <Step2
          {...props}
          formData={formData.step2}
          onNext={(value) => {
            setStep(step + 1);
            setFormData({ ...formData, step2: value });
          }}
          onBack={(value) => {
            setStep(step - 1);
            setFormData({ ...formData, step2: value });
          }}
        />
      )}
      {step === 3 && (
        <Step3
          {...props}
          formData={formData}
          selectedItems={selectedItems}
          disabledPORefNo={props.disabledPORefNo}
          onNext={(value) => {
            if (isSubmittingRef.current) {
              console.warn("🚨 Submission prevented: Already submitting!");
              return; // ✅ Prevent multiple executions
            }

            isSubmittingRef.current = true; // ✅ Set flag before any async operation
            console.log("✅ Processing Sales Submission...");

            setFormData((prevData) => ({ ...prevData, step3: value })); // ✅ Use functional update to prevent race conditions

            const payload = salesPayload(value);

            if (!selectedItems || selectedItems.length === 0) {
              console.log("📌 No `selectedItems` found. Calling `createSales`...");
              props.createSales(payload, (response2) => {
                handleSuccess(response2); // ✅ Ensure form resets after success
              });
            } else {
              props.createSales(payload, (response2) => {
                handleSuccess(response2); // ✅ Ensure form resets after success
              });
            }

            //}
          }}


          onBack={(value) => {
            setStep(step - 1);
            setFormData({ ...formData, step3: value });
          }}
        />
      )}
    </>
  );
};

export default PurchaseMonumentForm;
